import beautifyText from './beautifyText';

export default function beautifyField(contentState) {
  const blockMap = contentState.getBlockMap();

  const newBlockMap = blockMap.map(block => block.set('text', beautifyText(block.getText())));

  return contentState.set('blockMap', newBlockMap);
}
